import type { MusicOnHoldLocale } from './en'

export const musicOnHoldFrCa = {
  list: {
    title: `Musique d'attente`,
    loading: `Chargement des listes de lecture...`,
    error: `Erreur`,
    empty: `Aucune liste de lecture trouvée`,
    emptyDescription: `Il n'y a actuellement aucune liste de lecture configurée pour ce PBX.`,
    noResults: `Aucun résultat`,
    noResultsDescription: `Aucune liste de lecture ne correspond à votre recherche.`,
    columnName: `Nom`,
    columnType: `Type`,
    columnTracks: `Pistes`,
    columnUpdated: `Mis à jour`,
    columnDefault: `Par défaut`,
    columnPlayer: `Aperçu`,
    noPreview: `Aucun audio`,
    previewInDetail: `Ouvrir pour écouter les pistes`,
    defaultDisabledTooltip: `La liste de lecture doit contenir au moins une piste audio ou une URL de diffusion pour être définie par défaut.`,
    defaultCurrentTooltip: `Ceci est la liste de lecture par défaut actuelle.`,
    defaultSetTooltip: `Définir comme liste de lecture par défaut`,
    defaultBadge: `Par défaut`,
    systemBadge: `Système`,
    notPlayableBadge: `Non lisible`,
    typeList: `Liste`,
    tracksLabel: `pistes`,
    streaming: `En diffusion`,
    myPlaylists: `Mes listes de lecture`,
    systemPlaylists: `Listes système`,
    searchPlaceholder: `Rechercher des listes de lecture...`,
    manageTracksButton: `Pistes audio`,
    createButton: `+ Créer une liste`,
    createDisabledTooltip: `La création de liste n'est pas encore disponible.`,
    columnActions: `Actions`,
    deleteAriaLabelNamed: `Supprimer la liste "{{name}}"`,
    deleteConfirmTitle: `Supprimer la liste?`,
    deleteConfirmBody: `Supprimer "{{name}}"? Cette action est irréversible.`,
    deleteConfirm: `Supprimer`,
    deleteCancel: `Annuler`,
    deleteDefaultWarning: `Il s'agit de la liste de musique d'attente par défaut. La supprimer rétablira la liste par défaut du système.`,
  },
  detail: {
    loading: `Chargement de la liste de lecture...`,
    error: `Erreur`,
    notFound: `Liste de lecture introuvable.`,
    backToList: `← Retour à la liste`,
    editButton: `Modifier la liste`,
    editDisabledTooltip: `La modification n'est pas encore disponible`,
    defaultBadge: `Par défaut`,
    systemBadge: `Système`,
    generalTitle: `Informations générales`,
    nameLabel: `Nom`,
    typeLabel: `Type`,
    typeList: `Liste`,
    defaultLabel: `Par défaut`,
    defaultYes: `Oui`,
    defaultNo: `Non`,
    activeLabel: `Active`,
    activeYes: `Oui`,
    activeNo: `Non`,
    idLabel: `ID`,
    uuidLabel: `UUID`,
    createdLabel: `Créée`,
    updatedLabel: `Mis à jour`,
    audioTracksTitle: `Pistes audio`,
    noAudioTracks: `Aucune piste audio n'est associée à cette liste de lecture.`,
    manageTracksButton: `Gérer les pistes`,
  },
  audioTracks: {
    title: `Pistes audio`,
    loading: `Chargement des pistes audio...`,
    empty: `Aucune piste audio n'a été téléversée pour ce PBX.`,
    columnName: `Nom`,
    columnFile: `Fichier`,
    uploadButton: `Téléverser de la musique`,
    close: `Fermer`,
    nameLabel: `Nom de la piste`,
    namePlaceholder: `Entrez un nom pour la piste`,
    nameRequired: `Veuillez saisir un nom pour la piste.`,
    audioFileRequired: `Veuillez sélectionner un fichier audio.`,
    fileTypeInvalid: `Seuls les fichiers WAV ou MP3 sont pris en charge.`,
    fileSizeExceeded: `Le fichier dépasse la limite de 25 Mo ({{size}} Mo).`,
    dropzonePlaceholder: `Glissez-déposez un fichier WAV ou MP3 ici, ou cliquez pour parcourir`,
    dropzoneAccepted: `WAV, MP3 (max 25 Mo)`,
    removeFile: `Retirer`,
    cancel: `Annuler`,
    uploadSubmit: `Téléverser`,
    uploading: `Téléversement...`,
    uploadFailed: `Échec du téléversement`,
    deleteConfirmTitle: `Supprimer la piste audio?`,
    deleteConfirmBody: `Supprimer "{{name}}"? Cette action est irréversible.`,
    deleteConfirm: `Supprimer`,
    deleteFailed: `Échec de la suppression`,
    deleteAriaLabel: `Supprimer la piste audio`,
  },
  createModal: {
    title: `Nouvelle liste de lecture`,
    nameLabel: `Nom`,
    namePlaceholder: `Entrez le nom de la liste`,
    cancel: `Fermer`,
    submit: `Créer la liste de lecture`,
  },
  editModal: {
    title: `Modifier la liste de lecture`,
    nameLabel: `Nom`,
    namePlaceholder: `Entrez le nom de la liste`,
    cancel: `Annuler`,
    submit: `Enregistrer les modifications`,
    error: `Échec de l'enregistrement de la liste de lecture`,
  },
  manageTracks: {
    title: `Gérer les pistes`,
    inPlaylistTitle: `Dans cette liste de lecture`,
    availableTitle: `Pistes disponibles`,
    noneAssigned: `Aucune piste n'a encore été ajoutée à cette liste de lecture.`,
    noTracksUploaded: `Aucune piste audio n'a été téléversée pour ce PBX.`,
    allAdded: `Toutes les pistes disponibles sont déjà dans cette liste de lecture.`,
    add: `Ajouter`,
    remove: `Retirer`,
    done: `Terminé`,
    addFailed: `Échec de l'ajout de la piste`,
    removeFailed: `Échec du retrait de la piste`,
  },
  trackPlay: {
    play: `Lire`,
    loading: `Chargement…`,
    error: `Aperçu indisponible`,
    close: `Fermer l'aperçu`,
  },
  pagination: {
    resultsPerPage: `Résultats par page :`,
    previousPage: `Page précédente`,
    nextPage: `Page suivante`,
    jumpToPage: `Aller à la page {{page}}`,
    all: `Tous`,
  },
} satisfies MusicOnHoldLocale
